import { PrinterOutlined } from "@ant-design/icons";
import React, { useEffect, useRef, useState } from "react";
import ReactToPrint from "react-to-print";
import { useParams } from "react-router-dom";
import moment from "moment";
import Loadercomponent from "../../../../Componets/Loader";
import toast from "react-hot-toast";
import { get_transfer } from "../../../../Controllers/Inventory/Transfer";
import { get_receive } from "../../../../Controllers/Inventory/Received";
import URL from "../../../../Main/url";
import formatDateDDMMYYYY from "../../../../Main/formatDate";


const ReceivedView = () => {
  let componentRef = useRef();

  let { id } = useParams();
  const [loader, setLoader] = useState(false);

  const [details, setDetails] = useState();
  const [displayData, setDisplayData] = useState();

  const fetchData = async () => {
    setLoader(true);

    let data = {
      id: id,
    };

    let transfer = await get_receive(data);
    if (transfer?.status) {
      setDetails(transfer?.data);
      if (transfer?.data?.received_data) {
        setDisplayData(transfer?.data?.received_data);
      } else {
        setDisplayData(transfer?.data);
      }

      setLoader(false);
    } else {
      toast?.error(transfer?.message);
      setLoader(false);
    }
  };

  const injectScopedStyles = () => {
    const style = document.createElement("style");
    style.innerHTML = `
      @page {
        size: A4;
        margin: 6% 6% 16% 6%;
         @bottom-left {
          font-size: 12px;
          content: "\\A \\A \\A \\A Customer's Signature (Name/Designation/Co. Seal) \\A \\A \\A";
          white-space: pre;
          position: fixed;
          bottom: 10mm;
          left: 6%;
        }
        @bottom-right {
          font-size: 12px;
          content: "\\A \\A \\A \\A For ${displayData?.branch?.name} \\A \\A " counter(page) " of " counter(pages);
          white-space: pre;
          position: fixed;
          bottom: 10mm;
          right: 6%;
        }
      }
  
      @media print {
        .a4-invoice-footer {
          font-size: 12px;
          white-space: pre;
          position: fixed;
          bottom: 10mm;
          left: 6%;
        }
  
        .a4-invoice-footer-right {
          font-size: 12px;
          white-space: pre;
          position: fixed;
          bottom: 10mm;
          right: 6%;
        }
      }
    `;
    document.head.appendChild(style);
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  useEffect(() => {
    if (displayData?.branch?.name) {
      injectScopedStyles();
    }
  }, [displayData?.branch?.name]);

  const getDisplayData = () => {
    return displayData || details;
  };

  const data = getDisplayData();

  return (
    <div className="p-4">
      <Loadercomponent loader={loader}>
        <div className="flex justify-center">
          <div className="w-[8.27in]  text-right py-4">
            <ReactToPrint
              trigger={() => (
                <div className="">
                  <PrinterOutlined className="text-2xl" />
                </div>
              )}
              content={() => componentRef}
            />
          </div>
        </div>
        <div className="px-24">
          <div className="" ref={(el) => (componentRef = el)}>
            <div>
              <div className="text-black-900 text-[0.65rem] text-center">
                <div className="text-center">
                  {data?.supplier?.image ? (
                    <div className="flex justify-center">
                      <div className="text-xl pb-2">
                        <img
                          className="w-[50px] h-[50px]"
                          src={`${URL}/uploads${data?.supplier?.image}`}
                        />
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  <div className="text-medium text-xl">
                    {data?.supplier?.name}
                  </div>
                  <div className="text-medium">
                    {data?.supplier?.category}
                  </div>
                </div>
              </div>
              <div className="text-black-900 text-[0.65rem] text-center pt-4">
                <span>
                  Email&nbsp;:&nbsp;
                  {data?.supplier?.email
                    ? data?.supplier?.email + ", "
                    : ""}
                  &nbsp;
                </span>
                <span>
                  Phone&nbsp;:&nbsp;
                  {data?.supplier?.phone ? data?.supplier?.phone : ""}
                  &nbsp;
                </span>
                <div>
                  {data?.supplier?.area
                    ? data?.supplier?.area + ", "
                    : ""}
                  {data?.supplier?.city
                    ? data?.supplier?.city + ", "
                    : ""}
                  {data?.supplier?.country ? data?.supplier?.country : ""}
                </div>
                <div>
                  VATIN&nbsp;:&nbsp;
                  {data?.supplier?.tax ? data?.supplier?.tax : "N/A"}
                </div>
              </div>
              <hr className="my-4 border-t-black-900 border-black" />
              <div className="text-medium text-xl text-center">
                {details?.received_data ? "Received Order" : "Transfer Order"}
              </div>
              <div className="text-[0.60rem] pb-6">
                <div className="flex justify-between">
                  <div>
                    <table>
                      <tbody>
                        <tr>
                          <td className="">
                            {data?.branch?.name ? data?.branch?.name : ""}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {data?.branch?.phone
                              ? "Phone : " + data?.branch?.phone
                              : ""}
                            &nbsp;
                            {data?.branch?.email
                              ? ", Email : " + data?.branch?.email
                              : ""}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {data?.branch?.city
                              ? data?.branch?.city + ", "
                              : " "}
                            {data?.branch?.state}
                          </td>
                        </tr>
                        <tr>
                          <td>{data?.branch?.country}</td>
                        </tr>
                        <tr>
                          <td>
                            {data?.branch?.tax
                              ? "VATIN : " + data?.branch?.tax
                              : ""}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div>
                    <table>
                      <tbody>
                        <tr>
                          <td>{details?.received_data ? "Received No" : "Transfer No"}</td>
                          <td className="px-2">:</td>
                          <td className="text-right">
                            #{details?.received_data ? "RECEIVED" : "TRANSFER"}-{data?.number}
                          </td>
                        </tr>
                        {details?.received_data && (
                          <tr>
                            <td>Transfer No</td>
                            <td className="px-2">:</td>
                            <td className="text-right">
                              #TRANSFER-{details?.number}
                            </td>
                          </tr>
                        )}
                        <tr>
                          <td>Date</td>
                          <td className="px-2">:</td>
                          <td className="text-right">
                            {formatDateDDMMYYYY(data?.date)}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="">
                <table className="w-full">
                  <thead className="bg-black">
                    <tr className="text-[0.60rem]">
                      <th className="font-normal  text-white  text-left py-2 pl-3">
                        <div className="text-[0.60rem]">S.NO</div>
                      </th>
                      <th className="font-normal text-white text-left p-2">
                        <div className="text-[0.60rem]">DESCRIPTION</div>
                      </th>
                      <th className="font-normal text-white text-center p-2">
                        <div className="text-[0.60rem]">UNIT</div>
                      </th>
                      <th className="font-normal text-white text-center p-2">
                        <div className="text-[0.60rem]">QTY</div>
                      </th>
                      <th className="font-normal text-white text-center p-2">
                        <div className="text-[0.60rem]">RET.PRICE</div>
                      </th>
                      <th className="font-normal text-white text-center p-2">
                        <div className="text-[0.60rem]">W.S&nbsp;PRICE</div>
                      </th>
                      <th className="font-normal text-white text-center p-2">
                        <div className="text-[0.60rem]">DISC</div>
                      </th>
                      <th className="font-normal text-white text-center p-2">
                        <div className="text-[0.60rem]">FOC</div>
                      </th>
                      <th className="font-normal text-white text-center p-2">
                        <div className="text-[0.60rem]">VAT</div>
                      </th>
                      <th className="font-normal text-white text-right pr-2">
                        <div className="text-[0.60rem]">TOTAL</div>
                      </th>
                    </tr>
                  </thead>
                  <tbody className="text-sm">
                    {data?.details?.map((value, index) => {
                      return (
                        <tr className="uppercase border-b border-gray-300 " key={value?._id}>
                          <td className="text-[0.60rem] leading-[0.75rem] align-top">
                            <div className="pl-3">{index + 1}</div>
                          </td>
                          <td className="text-left leading-[0.75rem] align-top">
                            <div className="text-[0.60rem] p-0 m-0 text-medium">
                              {value?.name}
                            </div>
                            <div className="text-gray-500 p-0 m-0 text-[0.60rem]">
                              #BATCH-{value?.inventory?.number || value?.description?.number}
                            </div>
                            <div className="text-gray-500 p-0 m-0  text-[0.60rem]">
                              {value?.expiry_date
                                ? `Expiry : ${formatDateDDMMYYYY(
                                  value?.expiry_date
                                )}`
                                : ""}
                            </div>
                          </td>
                          <td className="text-center text-[0.60rem] leading-[0.75rem] align-top">
                            {value?.unit_name}
                          </td>
                          <td className="text-center text-[0.60rem] leading-[0.75rem] align-top">
                            {value?.quantity}
                          </td>
                          <td className="text-center text-[0.60rem] leading-[0.75rem] align-top">
                            {value?.sale_price?.toFixed(3)}
                          </td>
                          <td className="text-center text-[0.60rem] leading-[0.75rem] align-top">
                            {value?.wholesale_price?.toFixed?.(3) || value?.sale_price?.toFixed(3)}
                          </td>
                          <td className="text-center text-[0.60rem] leading-[0.75rem] align-top">
                            <div className="text-[0.60rem]">
                              {value?.discount_percentage || 0}%
                            </div>
                            <div className="text-[0.60rem] text-gray-500 leading-[0.75rem] align-top">
                              {value?.discount_price?.toFixed?.(3) || "0.000"}
                            </div>
                          </td>
                          <td className="text-center text-[0.60rem] leading-[0.75rem] align-top">
                            {value?.free ? value?.free : 0}
                          </td>
                          <td className="text-center leading-[0.75rem] align-top">
                            <div className="text-[0.60rem] ">{value?.tax || 0}%</div>
                            <div className="text-[0.60rem] text-gray-500">
                              {value?.tax_amount?.toFixed(3) || "0.000"}
                            </div>
                          </td>
                          <td className="text-right text-[0.60rem] leading-[0.75rem] align-top">
                            {value?.total?.toFixed(3)}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                  <tfoot className="text-xs text-medium leading-[0.75rem]">
                    <tr>
                      <th colSpan={8}></th>
                      <th className="font-normal text-right p-[4px]">
                        Subtotal
                      </th>
                      <td className="font-normal text-right p-[4px]">
                        {data?.subtotal?.toFixed(3)}
                      </td>
                    </tr>
                    <tr>
                      <th colSpan={8}></th>
                      <th className="font-normal text-right p-[4px]">
                        VAT (5%)
                      </th>
                      <td className="font-normal text-right p-[4px]">
                        {data?.taxamount?.toFixed(3)}
                      </td>
                    </tr>
                    <tr>
                      <th colSpan={8}></th>
                      <th className="font-normal text-right p-[4px]">
                        Discount
                      </th>
                      <td className="font-normal text-right p-[4px]">
                        {data?.discount_type
                          ? data?.discount_value
                            ? `${data?.discount?.toFixed(3)} (-${data?.discount_value
                            }%)`
                            : "0.000"
                          : data?.discount
                            ? `-${data?.discount?.toFixed(3)}`
                            : "0.000"}
                      </td>
                    </tr>
                    {data?.delivery ? (
                      <tr>
                        <th colSpan={8}></th>
                        <th className="font-normal text-right p-[4px]">
                          Delivery Charge
                        </th>
                        <td className="font-normal text-right p-[4px]">
                          +{data?.delivery?.toFixed(3)}
                        </td>
                      </tr>
                    ) : (
                      ""
                    )}
                    <tr>
                      <th colSpan={8}></th>
                      <th className="font-normal text-right text-white bg-black p-[4px]">
                        Total&nbsp;(OMR)
                      </th>
                      <td className="font-normal text-right text-white bg-black p-[4px]">
                        {data?.total?.toFixed(3)}
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
              <div className="pt-4 text-sm">
                <div className=""></div>
                <div className="pt-4"></div>
              </div>
            </div>
          </div>
        </div>
      </Loadercomponent>
    </div>
  );
};

export default ReceivedView;